const API = process.env.VUE_APP_API_URL ?? 'https://autosub-api.dev.beeonline.pro';
const HOST = 'autopodpiska.ru';

export { API, HOST };
